





































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { LineLayer } from "@/model/document2/page/surface/design/layer/lineLayer";

import { MathHelper } from "@/helper/mathHelper";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class LineEndController extends Vue 
{
    @Prop() layer! : LineLayer;

    private isValue(value : number)
    {
        return this.layer.endType == value;
    }

    private setValue(value : number)
    {
        this.changeLayerProperty("endType", value, true, true);
    }

    private get endWidth()
    {
        return MathHelper.clamp(this.layer.endWidth, -20, 20);
    }

    private set endWidth(endWidth)
    {
        this.changeLayerProperty("endWidth", Number(endWidth), false, false);
    }

    private onEndWidthChanged()
    {
        this.changeLayerProperty("endWidth", this.endWidth, true, false);
    }

    private get endWidthText()
    {
        return this.endWidth.toFixed(1) + "mm";
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
